import useUser from "../user/useUser";
import { useEffect } from "react";
import { isFollowing } from "../../api/listings";
import { useBlogCardFollowContext } from "../../components/blog/blogCard/blogCardModal";

type UseFollowingCoachFromBlogCard = {
  coachId: number;
};

export const useFollowingCoachFromBlogCard = ({
  coachId,
}: UseFollowingCoachFromBlogCard) => {
  const { user } = useUser();
  const { dispatch } = useBlogCardFollowContext();

  useEffect(() => {
    const getIsFollowing = async () => {
      if (user.token) {
        const isFollowingCoachFromBlog = await isFollowing(coachId, user.token);
        dispatch({ isFollowing: isFollowingCoachFromBlog });
      }
    };

    void getIsFollowing();
  }, []);
};
